import { useSyncExternalStore } from "react";
import { useTranslation } from "react-i18next";

import { SurveyAnswerContainer } from "../../../Answer Survey/AnswerSurveyPage.styles";
import { AnswerSurvey } from "../../../Answer Survey/Components/Survey";
import { MutedText } from "../../SurveyBuilder.styles";
import { readSurveyPreview, subscribeSurveyPreview } from "./previewBridge";

/** EN-5261: the page inside the builder's preview iframe (route /surveybuilder/preview). */
export function SurveyPreviewPage() {
  const { t } = useTranslation();
  const bridge = useSyncExternalStore(
    subscribeSurveyPreview,
    readSurveyPreview
  );

  if (!bridge) {
    return <MutedText>{t("surveys_builder_content_noQuestions")}</MutedText>;
  }

  // The same wrapper as the answering page: its side padding is what clips the next question's slide.
  return (
    <SurveyAnswerContainer>
      <AnswerSurvey
        key={bridge.revision}
        previewSurvey={bridge.survey}
        onPreviewFinish={bridge.onFinish}
      />
    </SurveyAnswerContainer>
  );
}
